import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";


const API_URL = window.location.href.includes("localhost")
  ? process.env.REACT_APP_API_URL_LOCAL
  : process.env.REACT_APP_API_URL_PROD;

export default function VisitorCount() {
  const [visitorData, setVisitorData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchVisitorData() {
      try {
        const res = await axios.get(
          `${API_URL}api/analytics/get-visitor-count`
        );
        if (res.data.success) {
          setVisitorData(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch visitor data:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchVisitorData();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 2, width: "100%", overflowX: "auto", mt: 8 }}>
      <Typography variant="h4" gutterBottom>
        Visitor Analytics
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="visitor table">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>System Name</TableCell>
              <TableCell>Visitor Count</TableCell>
              <TableCell>Last Visit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visitorData.map((visitor) => (
              <TableRow key={visitor._id}>
                <TableCell>{visitor.dateKey}</TableCell>
                <TableCell>Skyline Properties</TableCell>
                <TableCell>{visitor.count}</TableCell>
                <TableCell>
                  {new Date(visitor.lastVisit).toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
